import React, { memo } from "react";
import { DrawerModal } from "../drawer-modal/drawer-modal";
import styles from "./ota-configuration-drawer-modal.module.scss";
import { Title } from "@src/components/atoms/title/title";
import { DrawerIconContainer } from "@src/components/atoms/drawer-icon-container/drawer-icon-container";
import { FlexColumnContainer } from "@src/components/templates/layouts/flex-column-container/flex-column-container";
import FirmwareUploadIcon from "@src/assets/svg/firmware-upload.svg";
import ConfigurationIcon from "@src/assets/svg/configurations-icon-active.svg";

import { FlexRowContainer } from "@src/components/templates/layouts/flex-row-container/flex-row-container";
import { Button } from "@src/components/atoms/buttons/button/button";
import { ButtonWithLoader } from "@src/components/atoms/buttons/button-with-loader/button-with-loader";
import { DrawerButtonWrapper } from "@src/components/molecules/drawer-button-wrapper/drawer-button-wrapper";
import { OtaDrawerDataInterface } from "@src/types/ota-update";
import { OtaDrawerForm } from "@src/components/molecules/ota-drawer-form/ota-drawer-form";
import OtaDrawerInfo from "@src/components/molecules/ota-drawer-info/ota-drawer-info";
import { useOtaConfigurationDrawerModal } from "./use-ota-configuration-drawer-modal";

const cssClassName = "ota-configuration-version-drawer-modal";
interface OtaConfigurationsDrawerModalProps {
  inputValues: OtaDrawerDataInterface;
  setInputValues: React.Dispatch<React.SetStateAction<OtaDrawerDataInterface>>;
}
export const OtaConfigurationDrawerModal = memo(
  ({ inputValues, setInputValues }: OtaConfigurationsDrawerModalProps) => {
    const { texts, handleCloseDrawerModal, handleSubmit } =
      useOtaConfigurationDrawerModal({
        inputValues,
        setInputValues,
      });

    return (
      <DrawerModal id="otaConfigurationDrawerModal">
        <div className={styles[cssClassName]}>
          <FlexColumnContainer verticalGap={24}>
            <Title tag="h2" text={texts.releaseNewConfigurationText} />
            <DrawerIconContainer icon={FirmwareUploadIcon} />

            <div className={styles[`${cssClassName}__content-wrapper`]}>
              <FlexRowContainer horizontalGap={8}>
                <img
                  className={styles[`${cssClassName}__container-icon`]}
                  alt={"Configuration"}
                  src={ConfigurationIcon}
                />
                <p className={styles[`${cssClassName}__subtitle`]}>
                  {texts.releaseConfigurationDetailsText}
                </p>
              </FlexRowContainer>

              <div className={styles[`${cssClassName}__metadata-box`]}>
                <OtaDrawerInfo />
                <OtaDrawerForm
                  values={inputValues}
                  setValues={setInputValues}
                />
              </div>

              <DrawerButtonWrapper>
                <ButtonWithLoader
                  fun={handleSubmit}
                  text={texts.releaseConfigurationText}
                  loading={false}
                />
                <Button
                  fun={handleCloseDrawerModal}
                  text={texts.cancelText}
                  variant={"secondary"}
                />
              </DrawerButtonWrapper>
            </div>
          </FlexColumnContainer>
        </div>
      </DrawerModal>
    );
  },
);

OtaConfigurationDrawerModal.displayName = "OtaConfigurationDrawerModal";
